// extracted by mini-css-extract-plugin
export default {"fr-view":"Modal_fr-view__tx6H2","overlay":"Modal_overlay__HJeQl","modal":"Modal_modal__V7NMi"};